module.exports = __webpack_public_path__ + "static/media/0024_IMG_FE_LES_ENSEIGNES_LES_FROMAGES_SCRABBLE.02694b82.png";